<div class="p-4">
  <div class="m-3 mb-8 flex flex-row justify-between">
    <div class="flex flex-row gap-4">
      <input
        type="text"
        class="input input-bordered w-80"
        placeholder="Search"
        [(ngModel)]="searchText"
        (input)="updateQueryParams()"
      />
      <!-- (input)="updateDisplayProducts()" -->

      <div class="form-control">
        <label class="label cursor-pointer">
          <input
            type="checkbox"
            class="checkbox mr-2"
            [(ngModel)]="showInactiveProducts"
            (change)="updateQueryParams()"
          />
          <span class="label-text">Show Inactive Products</span>
        </label>
      </div>
    </div>
    <button class="btn btn-primary" [routerLink]="['/admin/add-product']">
      <app-plus-icon class="h-6 w-6"></app-plus-icon>
      Add Product
    </button>
  </div>
  <div class="overflow-x-auto rounded-lg border border-base-content/20">
    <table
      class="table table-pin-rows table-pin-cols"
      [ngClass]="{
        'table-lg': spacing === 'comfortable',
        'table-md': spacing === 'normal',
        'table-xs': spacing === 'compact',
      }"
    >
      <thead class="text-base font-medium">
        <td>Title</td>
        <td class="w-1 whitespace-nowrap">Code</td>
        <td class="w-1 whitespace-nowrap">Variance</td>
        <td class="w-1 whitespace-nowrap">Type</td>
        <td class="w-1 whitespace-nowrap">Is Default</td>
        <td class="w-1 whitespace-nowrap">Active</td>
        <td class="w-1 whitespace-nowrap">Licenses</td>
        <td class="w-1 whitespace-nowrap">Created</td>
      </thead>
      <tbody>
        @for (product of currentPageProducts; track product; let i = $index) {
          <tr
            class="cursor-pointer text-base"
            [ngClass]="{ 'bg-base-200': i % 2 === 0 }"
            (click)="navigateToProductDetails(product)"
          >
            <td>{{ product.title }}</td>
            <td class="w-1 whitespace-nowrap">{{ product.code }}</td>
            <td class="w-1 whitespace-nowrap">{{ product.variance_code }}</td>
            <td class="w-1 whitespace-nowrap">{{ product.type }}</td>
            <td class="w-1 whitespace-nowrap">
              @if (product.is_default) {
                <app-check-icon class="mx-auto block h-4 w-4"></app-check-icon>
              }
            </td>
            <td class="w-1 whitespace-nowrap">
              @if (product.active) {
                <app-check-icon class="mx-auto block h-4 w-4"></app-check-icon>
              }
            </td>
            <td class="w-1 whitespace-nowrap text-center">
              {{ product.active_desktop_license_count ?? 0 }}
            </td>
            <td class="w-1 whitespace-nowrap">
              {{ product.created_at | date: 'MM/dd/yyyy, hh:mmaa' }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  @if (loading) {
    <div class="mt-5 flex justify-center">
      <span class="loading loading-spinner loading-md"></span>
    </div>
  } @else {
    <div class="mt-5">
      <app-pagination
        [spacing]="spacing"
        [pageSize]="pageSize"
        [currentPage]="currentPage"
        [totalPages]="totalPages"
        (pageChanged)="currentPage = $event"
        (settingsChanged)="handleSettingsChanged($event)"
      ></app-pagination>
    </div>
  }
</div>
